import { render, staticRenderFns } from "./balanceRechargeRecord.vue?vue&type=template&id=207e8dea&scoped=true&"
import script from "./balanceRechargeRecord.vue?vue&type=script&lang=js&"
export * from "./balanceRechargeRecord.vue?vue&type=script&lang=js&"
import style0 from "./balanceRechargeRecord.vue?vue&type=style&index=0&id=207e8dea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207e8dea",
  null
  
)

export default component.exports